import React, { useState } from "react";
import "./Home_product_slider.css";
import Common_Product_Card from "../../common_components/common_product_card/Common_Product_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import { useNavigate } from "react-router-dom";
import Common_Heading_Holder from "../../common_components/common_heading_holder/Common_Heading_Holder";

const Home_product_slider = ({
  button_color,
  background_color,
  multiple,

  ...props
}) => {
  const navigate = useNavigate();

  return (
    <section className="Common_Product_Swiper">
      <div className="card_heading_div">
        <Common_Heading_Holder
          headingText={"Premium Meat and Poultry Selection"}
          viewShowAllButton={true}
          goto={`/all-product`}
          data={props?.data}
        />
      </div>

      <div className="products_main_div">
        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          modules={[Pagination]}
          autoplay={{ delay: 300 }}
          className="common_swiper"
          breakpoints={{
            0: {
              slidesPerView: 1.3,
            },
            350: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3.5,
            },
            992: {
              slidesPerView: 3.2,
            },
            1200: {
              slidesPerView: 4,
            },
            1400: {
              slidesPerView: 5,
            },
          }}
        >
          {props?.data?.length > 0 ? (
            props?.data?.map((item) => (
              <SwiperSlide key={item?.id}>
                <Common_Product_Card
                  button_color={button_color}
                  prodImg={item?.image}
                  prodName={item?.name}
                  product={item}
                  background_color={background_color}
                  //   goto={`/product-listing-sub-category/${item?.id
                  //     }?category_name=${encodeURIComponent(
                  //       item?.name
                  //     )}&category_image=${encodeURIComponent(item?.image)}`}
                />
              </SwiperSlide>
            ))
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "40px 0",
                fontSize: "18px",
                color: "#666",
              }}
            >
              <span
                style={{
                  fontSize: "30px",
                  display: "block",
                  fontWeight: "bold",
                }}
              >
                🛒
              </span>
              <span style={{ fontWeight: "bold" }}>No products available</span>
            </div>
          )}
        </Swiper>
      </div>
    </section>
  );
};
export default Home_product_slider;
